import { mockUUID } from './mockPageService.mjs';
import { flatProductList } from '../../utils/helpers/productHelper.mjs';

const satisfyTheQuestions = (questionGroups) => {
  let questionCount = 0;
  const unsatisfiedMod = 12;
  questionGroups.map((group) => {
    (group.questions || []).map((q) => {
      q.satisfied = questionCount % unsatisfiedMod !== 10;
      questionCount++;
    });
  });
  return questionGroups;
};

const getPagesByPath = (pages) =>
  pages
    .filter((p) => p.type === 'survey' && p.pathKey)
    .reduce((acc, page) => {
      const pathKey = page.pathKey;
      const pageToInsert = {
        key: page.pathPage,
        questionGroups: satisfyTheQuestions(page.page.questionGroups || []),
      };
      if (!acc[pathKey]) {
        acc[pathKey] = {
          key: pathKey,
          satisfied: true,
          pages: [pageToInsert],
        };
      } else {
        acc[pathKey] = {
          ...acc[pathKey],
          pages: [...acc[pathKey].pages, pageToInsert],
        };
      }
      return acc;
    }, {});

const mockConversationTestService = {
  loadGuideConversationForTesting(mockPages) {
    const pagesByPath = getPagesByPath(mockPages);
    const questionPaths = [];
    /* eslint-disable-next-line no-unused-vars */
    for (let [key, value] of Object.entries(pagesByPath)) {
      questionPaths.push(value);
    }

    const localAnswers = JSON.parse(window.sessionStorage.getItem(`${mockUUID}-localAnswers`)) || {};
    const answers = [];
    /* eslint-disable-next-line no-unused-vars */
    for (let [key, value] of Object.entries(localAnswers)) {
      answers.push(value);
    }

    const summaryPage = mockPages.find((p) => p.type === 'summary');
    const productGroups = summaryPage.products || {};
    const products = flatProductList(productGroups);

    return {
      answers,
      products,
      productGroups: [productGroups],
      questionPaths: questionPaths,
    };
  },
};

export { mockConversationTestService };
